// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
// // import Table from "../Table";
// import "./style.css";
// import * as XLSX from "xlsx";
// import { v4 as uuid } from "uuid";
// import { RotateSpinner } from "react-spinners-kit";
// import Select from "react-select";
// import Header from "../Header/Header";
// import Navbar from "../Header/Navbar";

import Poc from "../Common/POC";

// import Button from '@mui/material/Button';
// import Paper from '@mui/material/Paper';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TablePagination from '@mui/material/TablePagination';
// import TableRow from '@mui/material/TableRow';
// import ActionButton from "../Common/ActionButton";
// import { ROUTER_URL, LABEL_NAME } from "../Common/constant";

// const columns = [
//   { id: 'Sl_No', label: 'Sl No', minWidth: 50 },
//   { id: 'uploadRefNo', label: 'Upload Ref No', minWidth: 100 },
//   { id: 'userRefId', label: 'User Ref Id', minWidth: 100 },
//   { id: 'requestType', label: 'Request Type', minWidth: 100 },
//   { id: 'insurerCode', label: 'Insurer Code', minWidth: 100 },
//   { id: 'fileId', label: 'File Id', minWidth: 100 },
//   { id: 'fileName', label: 'File Name', minWidth: 100 },
//   { id: 'dateOfEntry', label: 'Date of Entry', minWidth: 100 },
//   { id: 'numOfRec', label: 'Num of Records', minWidth: 100 },
//   { id: 'typeOfFile', label: 'Type of File', minWidth: 100 },
//   { id: 'folderPath', label: 'Folder Path', minWidth: 100 },
//   { id: 'individualBulk', label: 'Individual/Bulk', minWidth: 100 },
//   { id: 'reqResErr', label: 'Request/Response/Error', minWidth: 100 },
//   {
//     id: 'remarks',
//     label: 'Remarks',
//     minWidth: 170,
//     align: 'right',
//     // format: (value) => value.toLocaleString('en-US'),
//     // format: (value) => value.toFixed(2),
//   }
// ];
// function InsurerDetails(props) {
//   const [page, setPage] = React.useState(0);
//   const [rowsPerPage, setRowsPerPage] = React.useState(5);

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   const currentDate = new Date();

//   // Format the date components individually
//   const year = currentDate.getFullYear();
//   const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
//   const day = currentDate.getDate().toString().padStart(2, '0');
//   const hours = currentDate.getHours().toString().padStart(2, '0');
//   const minutes = currentDate.getMinutes().toString().padStart(2, '0');
//   const seconds = currentDate.getSeconds().toString().padStart(2, '0');
//   const milliseconds = currentDate.getMilliseconds().toString().padStart(3, '0');


//   const [insurerData, setInsurerData] = useState([]);
//   const [selectedInsurer, setSelectedInsurer] = useState('Select');

//   // Combine the components into the desired format
//   const timeStamp = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}00`;

//   const [showTable, setShowTable] = useState(false);
//   const [value, setValue] = useState('');
//   const [responseData, setResponseData] = useState([]);
//   const [loading, setLoading] = useState(false);


//   // New unique id
//   const unique_id = uuid();

//   // Get first 8 characters using slice
//   const small_id = unique_id.slice(0, 8);





//   const [insurerCode, setInsurerCode] = useState("");
//   const [insurerName, setInsurerName] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   const date = new Date();
//   const formattedDate = date.toLocaleDateString('en-GB');

//   const navigate = useNavigate()

//   const backbutton = () => {
//     navigate('/menudisplaypage')
//   }

//   const todayDate = new Date().toISOString().split('T')[0];

//   function formatDate(dateString) {
//     const dateObject = new Date(dateString);
//     const day = dateObject.getDate();
//     const month = dateObject.getMonth() + 1; // Months are zero-based
//     const year = dateObject.getFullYear();

//     // Pad single-digit day and month with a leading zero
//     const formattedDay = day < 10 ? `0${day}` : day;
//     const formattedMonth = month < 10 ? `0${month}` : month;

//     return `${formattedDay}/${formattedMonth}/${year}`;
//   }


//   const handleButtonClick = async (e) => {

//     e.preventDefault();
//     if (!selectedInsurer || !fromDate || !toDate || selectedInsurer === "Select") {
//       alert("Please fill in all mandatory fields.");
//       setLoading(false)

//       return;
//     }
//     // const formattedFromDate = formatDate(fromDate);
//     // const formattedToDate = formatDate(toDate);
//     const formattedFromDate = new Date(fromDate).toLocaleDateString('en-GB'); // Assumes 'toDate' is in the format "YYYY-MM-DD"


//     const formattedToDate = new Date(toDate).toLocaleDateString('en-GB'); // Assumes 'toDate' is in the format "YYYY-MM-DD"


//     const BaseUrl = process.env.REACT_APP_API_URL

//     const EndPoint = "/riInsurerBulkService/v1/SFTPUploadList"

//     try {
//       const response = await fetch(`${BaseUrl}${EndPoint}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             txnId: "9e5adbbe-39ae-72e8-a8d7-0289147bf002",
//             timestamp: "2023-11-20T16:33:25.387994200",
//             Source: {
//               appType: "WEB",
//               osVersion: "11",
//               deviceId: "",
//               deviceName: "Windows108",
//               deviceOS: "Windows",
//               appVersion: "1.0",
//               clientIp: "0.0.0.0",
//               origin: "RI",
//             },
//             Customer: {
//               insurerCode: insurerCode,
//               fromDate: formattedFromDate,
//               toDate: formattedToDate,
//             },
//           }),
//         }
//       );

//       if (response.ok) {
//         let jsonResponse = await response.json();
//         for (let i = 0; i < jsonResponse.SftpUploadList.length; i++) {
//           jsonResponse.SftpUploadList[i] = { "Sl_No": i + 1, ...jsonResponse.SftpUploadList[i] };
//         }
//         setResponseData(jsonResponse.SftpUploadList);
//         setShowTable(true);

//       } else {
//         // Handle errors
//         const errorResponse = await response.json();
//         alert(` Error: ${errorResponse.errorDescription}`);
//       }
//     } catch (error) {
//       // Handle network errors or any other exceptions
//       alert(`Error: ${error.message}`)
//     }

//   };

//   const handleReset = (e) => {
//     e.preventDefault();
//     // clearing the values
//     setSelectedInsurer("Select");
//     setInsurerCode("");
//     setInsurerName("");
//     setFromDate("");
//     setToDate("");
//     setShowTable(false)
//     setLoading(false)
//   }


//   const handleExportClick = () => {
//     // Export response data as Excel
//     exportAsExcel(responseData);
//   };


//   const exportAsExcel = (data) => {
//     console.log(data)
//     const ws = XLSX.utils.json_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
//     XLSX.writeFile(wb, 'POCList.xlsx');
//   };

//   //string to plaintext download 

//   function downloadTextFile(textContent, fileName) {
//     const blob = new Blob([textContent], { type: 'text/plain' });
//     const url = URL.createObjectURL(blob);

//     let a = document.getElementById('download-link') || document.createElement('a');
//     a.id = 'download-link';
//     a.href = url;
//     a.download = fileName;
//     a.click();

//     URL.revokeObjectURL(url);
//   }

//   const handleClickPlain = (requestXML, fileName) => {
//     const xmlString = requestXML;

//     // Use the XML string directly without parsing it as HTML
//     downloadTextFile(xmlString, `${fileName}`);
//   };

//   const BaseUrl = process.env.REACT_APP_API_URL
//   const apiUrl = BaseUrl + "/riInsurerBulkService/v1/ListInsurerWithLogo";

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch(apiUrl, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify({
//             txnId: uuid(),
//             timestamp: '2023-07-25T09:56:20.501636500',
//             Source: {
//               appType: 'MOBILE',
//               osVersion: '11',
//               deviceId: '',
//               deviceName: 'Mymobile 52',
//               deviceOS: 'Android',
//               appVersion: '2.0',
//               clientIp: '0.0.0.0',
//               origin: '',
//             },
//           }),
//         });

//         const data = await response.json();

//         if (data && data.MasterData) {
//           setInsurerData(data.MasterData);
//           console.log(insurerData)
//         }
//       } catch (error) {
//         console.error('Error fetching data:', error);
//       }
//     };

//     fetchData();
//   }, []); // Empty dependency array ensures the effect runs once when the component mounts

//   // const handleInsurerSelect = (code, description) => {
//   //   setSelectedInsurer(`${code} / ${description}`);

//   // };

//   const handleInsurerSelect = (selectedValue) => {
//     // Parse selectedValue to get insurer code and description
//     const [code, description] = selectedValue.split('/');

//     // Do something with code and description
//     setInsurerCode(code)

//     // Set the selected insurer state if needed
//     setSelectedInsurer(selectedValue);
//   };


//   let options = insurerData.map((insurer) => ({
//     value: `${insurer.Code}/${insurer.Description}`,
//     label: `${insurer.Code}/${insurer.Description}`,
//   }));

//   options = [{ label: "Select", value: "Select" }, ...options]


//   const customStyles = {
//     control: (provided) => ({
//       ...provided,
//       width: '398px', // Set your desired width
//       height: '10px', // Set your desired height
//     }),
//     option: (provided, state) => ({
//       ...provided,
//       color: state.isSelected ? 'white' : 'black', // Set your desired text color
//       backgroundColor: state.isSelected ? 'blue' : 'white', // Set your desired background color when selected
//     }),
//   };

//   return (
//     <div>
//       <Header />
//       <div className="MenuPage">
//         <Navbar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
//       </div>
//       <div className="app-insurer">
//         <div>
//           <h1 className="heading1">{ROUTER_URL.POC_UPLOAD_LIST}</h1>
//         </div>



//         {/* Add your text fields and button for user input */}
//         <div className="row col-12">
//           <div className='col-12'>
//             <form method="post">
//               <div class='row'>
//                 <div className="col-4 username">
//                   <div>
//                     <label className="label_cls" >{LABEL_NAME.INSURER_CODE_NAME}</label>
//                   </div>
//                   <div class='' style={{ width: '100%' }}>
//                     <Select
//                       className="inputboxvu_insure" style={{ padding: '4px' }}
//                       value={{ value: selectedInsurer, label: selectedInsurer }}
//                       options={options}
//                       onChange={(selectedOption) => handleInsurerSelect(selectedOption.value)}
//                       placeholder="Select an insurer"
//                       styles={customStyles}
//                     />
//                   </div>
//                 </div>
//                 <div className="username col-2">
//                   <label className="label_cls" >{LABEL_NAME.FROM_DATE}</label>
//                   <div class=''>
//                     <input type="date" name="fromDate" value={fromDate} className="inputboxvu_insure form-control" max={todayDate} onChange={(e) => setFromDate(e.target.value)} required />
//                   </div>
//                 </div>
//                 <div className="username col-2">
//                   <label className="label_cls" >{LABEL_NAME.TO_DATE}</label>
//                   <div class=''>
//                     <input type="date" name="toDate" value={toDate} className="inputboxvu_insure form-control" max={todayDate} onChange={(e) => setToDate(e.target.value)} required />
//                   </div>
//                 </div>

//                 <div className="username col-4">
//                   <ActionButton handleBack={backbutton} handleReset={handleReset} handleSubmit={handleButtonClick} />
//                 </div>
//                 <p className="note"> Note: {LABEL_NAME.INSURER_NOTE}</p>
//               </div>

//             </form>
//             <div className="loading">
//               <RotateSpinner
//                 size={70}
//                 color="#f99117"
//                 loading={loading}
//               />
//             </div>
//           </div>
//           <div className='col-12'>
//             <div className="item-insurer">
//               <div className="tableContainer-insurer">
//                 {showTable && (
//                   <div className="">
//                     <button onClick={handleExportClick} className="export-button">Export as Excel</button>
//                     {/* <Button variant="outlined">Outlined</Button> */}
//                     <div class=''>
//                       <Paper sx={{ width: '100%', overflow: 'hidden' }}>
//                         <TableContainer sx={{ maxHeight: 440 }}>
//                           <Table stickyHeader aria-label="sticky table">
//                             <TableHead>
//                               <TableRow>
//                                 {columns.map((column) => (
//                                   <TableCell
//                                     key={column.id}
//                                     align={column.align}
//                                     style={{ minWidth: column.minWidth }}
//                                   >
//                                     {column.label}
//                                   </TableCell>
//                                 ))}
//                               </TableRow>
//                             </TableHead>
//                             <TableBody>
//                               {responseData
//                                 .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                                 .map((row, index) => {
//                                   //debugger;
//                                   console.log(row, index);
//                                   return (
//                                     <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
//                                       {columns.map((column) => {
//                                         const value = row[column.id];
//                                         return (
//                                           <TableCell key={column.id} align={column.align}>
//                                             {/* {column.format && typeof value === 'number'
//                                               ? column.format(value)
//                                               : value} */}
//                                             {value}
//                                             {column.id === 'reqResErr' && row.reqResErr === "Request" && row.requestXML !== "" ? <Button variant="contained" className="request-button ml-2" onClick={() => handleClickPlain(row.requestXML, row.fileName)}>Download</Button> : ''}
//                                           </TableCell>
//                                         );
//                                       })}
//                                     </TableRow>
//                                   );
//                                 })}
//                             </TableBody>
//                           </Table>
//                         </TableContainer>
//                         <TablePagination
//                           rowsPerPageOptions={[5, 10, 25, 100]}
//                           component="div"
//                           count={responseData.length}
//                           rowsPerPage={rowsPerPage}
//                           page={page}
//                           onPageChange={handleChangePage}
//                           onRowsPerPageChange={handleChangeRowsPerPage}
//                         />
//                       </Paper>
//                     </div>

//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>



//       </div >
//     </div >
//   );
// }

function InsurerDetails(props) {
  return <Poc isPOC={false} />;
}

export default InsurerDetails;
